import Vue from 'vue'
import {$http} from '@/utils/https'
import {
    CHANGE_CATEGORY,
    CHANGE_LAST_STEP_ID,
    CHANGE_LOADING,
    CHANGE_PROGRESS_LOADING,
    CHANGE_SKIP,
    CHANGE_STEP,
    CHANGE_USER_ACTION_PLAN_STATUS,
    SET_ITEM,
    SET_LIST,
    SET_LIST_LENGTH
} from '../mutation-types';

import {GET_LIST, GET_LIST_ITEM, UPDATE_PROGRESS} from '../action-types';


const state = {
    list: [],
    currentItem: null,
    isLoading: false,
    skip: 0,
    limit: 9,
    listLength: 0,

    activeCategory: '',

    activeStep: 0,
    lastItemIndex: 0,
    isProgressLoading: false,

};

const getters = {
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    limit: state => state.limit,
    isLoading: state => state.isLoading,
    activeStep: state => state.activeStep,
    lastItemIndex: state => state.lastItemIndex,
    isProgressLoading: state => state.isProgressLoading,
};

const actions = {
    [GET_LIST]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            if (payload.isResetList) {
                commit(SET_LIST, []);
                commit(CHANGE_SKIP, true)
            } else commit(CHANGE_SKIP);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}action-plans?include=category,seo,country,picture.seo,authors.user,userActionPlan&limit=${state.limit}&skip=${state.skip}&filters[categories]=${state.activeCategory}`);

            if (payload.isResetList) {
                commit(SET_LIST, [])
            }
            commit(SET_LIST, response.data.data);
            commit(SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}action-plans/${payload.slug}?include=seo,contents,contents.files,cover.seo,picture.seo,category,userActionPlan&use_as_id=slug`);
            commit(SET_ITEM, response.data.data);
            if (response.data.data.userActionPlan.data.hasOwnProperty('lastCompletedContentId')) {
                commit(CHANGE_LAST_STEP_ID, response.data.data.userActionPlan.data.lastCompletedContentId);
            }
            return response.data.data;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
    [UPDATE_PROGRESS]: async ({commit}, payload) => {
        try {
            commit(CHANGE_PROGRESS_LOADING, true);

            if (payload.type === 'start') {
                await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/action-plans/${payload.id}/start`);
            } else if (payload.type === 'complete') {
                const response = await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/action-plans/${payload.id}/complete`, payload);
                commit(CHANGE_USER_ACTION_PLAN_STATUS, {...response.data.data, actionPlanId: payload.id})
            } else {
                await $http.post(`${process.env.VUE_APP_ROOT_EDUCATION}user/action-plans/${payload.id}/next/${payload.completedId}`);
            }
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_PROGRESS_LOADING, false);
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (!data.length) {
            state.list = []
            return;
        }
        if (state.list) {
            state.list.push(...data);
        } else {
            state.list = data;
        }
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [CHANGE_SKIP](state, status = false) {
        if (status) state.skip = 0
        else state.skip += state.limit;
    },
    [CHANGE_USER_ACTION_PLAN_STATUS](state, data) {
        const index = state.list.findIndex(e => e.id === data.actionPlanId);
        Vue.set(state.currentItem.userActionPlan, 'data', data)
        Vue.set(state.list[index].userActionPlan, 'data', data)
    },
    [SET_ITEM](state, data) {
        if (data && data.hasOwnProperty('authors')) {
            data.speakers = data.authors
        }
        state.currentItem = data;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_STEP](state, number) {
        state.activeStep = number;
    },
    [CHANGE_PROGRESS_LOADING](state, status) {
        state.isProgressLoading = status;
    },
    [CHANGE_LAST_STEP_ID](state, id) {
        const index = state.currentItem.contents.data.findIndex(e => e.id === id);
        if (index > 0) {
            state.lastItemIndex = index;
        } else {
            state.lastItemIndex = 0;
        }

    },
    [CHANGE_CATEGORY](state, category = '') {
        state.activeCategory = category;
        state.skip = 0;
        state.listLength = 0;
        state.list = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
